import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store'
import { Provider } from 'react-redux'
import MyThemeProvider from './theme/myThemeProvider';
import MyRoutes from './routes';
import UpdateManager from './components/UpdateManager';

// deploy to s3
// aws s3 sync build/ s3://s10-ps-prod-portal-colaborador

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <UpdateManager/>
    <MyThemeProvider>
      <Provider store={store}>
        <MyRoutes />
      </Provider>
    </MyThemeProvider>
  {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
